
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/tv3/marato/foto-galeries",
      function () {
        return require("private-next-pages/corporatiu/tv3/marato/foto-galeries/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/tv3/marato/foto-galeries"])
      });
    }
  